import { FC } from 'react'

import { useGET_studentsQuery } from 'redux/api/studentsApi'

import PageHeading from 'components/atoms/PageHeading'
import MainTable from 'components/organisms/tables/MainTable'
import GroupCourseEnrollStudentForm from 'components/organisms/forms/GroupCourseEnrollStudentForm'

import { useTableModel } from 'utils/tableModels/useGroupCourseEnrolledStudentsTableModel'

import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'
import { removeEmpty } from 'utils/helpers'


interface IProps {
  id: number
  viewOnly: boolean
  tabText?: string
  tabKey?: string
}

  
const GroupCourseEnrolledStudents: FC<IProps> = ({ id, viewOnly }) => {
  const { t } = useTranslation()
  const filters = {
    group_course: id,
  }

  return (
    <>
      <Grid container spacing={4} sx={{ marginTop: '-1rem' }}>
        <Grid item xs={6}>
          <PageHeading title={t('common.enrolled-students')} />
        </Grid>
        <Grid item xs={6}>
          <GroupCourseEnrollStudentForm id={id} viewOnly={viewOnly} />
        </Grid>
      </Grid>

      <MainTable
        useTableModel={useTableModel}
        getTableData={useGET_studentsQuery}
        tableRowParams={ {group_course_id: id} }
        filters={removeEmpty(filters)}
        header={null}
      />
    </>
  )
}
export default GroupCourseEnrolledStudents
